import moment from "moment";

export default {
  data() {
    return {
      dialog: false,
      clienti_sel: [],
      zona: "Tutte",
      text_send: null,
      radios: "free",
      loading: false,
      dialog_new_text: false,
      text_modello: null,
      id_modello: null,
      giorni: [
        { text: "Oggi", value: moment().format("X") },
        { text: "Domani", value: moment().add(1, "days").format("X") },
        { text: "Dopodomani", value: moment().add(2, "days").format("X") },
        { text: "Lunedì", value: moment().isoWeekday(8).format("X") },
      ],
      giorno: { text: "Domani", value: moment().add(1, "days").format("X") },
      limite_ordine: { text: "Oggi", value: moment().format("X") },
      ora: moment().add(4, "hours").format("HH:mm"),
      menu_ora: false,
      msg_pers: false,
    };
  },
  computed: {
    zone() {
      return this.$store.getters.get_zone;
    },
    clienti() {
      return this.$store.getters.get_clienti.filter((cliente) => this.isValidItalianPhoneNumber(cliente.telefono)); 
    },
    clienti_filter() {
      if (this.zona == "Tutte") {
        return this.clienti;
      }
      return this.clienti.filter((cliente) => cliente.zona == this.zona);
    },
    fix_texts() {
      return this.$store.getters.get_testi_broadcast;
    },
    to_send() {
      return this.radios == "free" ? this.text_send : this.radios;
    },
  },
  watch: {
    zona: function () {
      this.clienti_sel = [];
    },
    $route(to, from) {
      if (from.hash === "#nuovo_broadcast" && this.dialog) {
        this.dialog = false;
      }
    },
  },
  methods: {
    open() {
      this.$router.push("#nuovo_broadcast");
      this.dialog = true;
    },
    close() {
      this.$router.back();
      this.dialog = false;
    },
    remove(item) {
      const index = this.clienti_sel.indexOf(item.iva);
      if (index >= 0) this.clienti_sel.splice(index, 1);
    },
    invia_broadcast() {
      this.loading = true;
      this.$store
        .dispatch("invia_broadcast", {
          clienti: this.clienti_sel,
          id_modello: "passaggio_da_settare",
          params: {
            ora: this.ora,
            giorno: this.giorno,
            limite_ordine: this.limite_ordine,
            zona: this.zona,
          },
        })
        .finally(() => {
          this.loading = false;
          this.close();
        });
    },
    invia_broadcast_immagine() {
      this.loading = true;
      this.$store
        .dispatch("invia_broadcast_immagine", {
          clienti: this.clienti_sel,
          id_modello: this.radios,
        })
        .finally(() => {
          this.loading = false;
          this.close();
        });
    },
    send_new_text() {
      this.$store
        .dispatch("new_testo_broadcast", {
          id_modello: this.id_modello,
          text: this.text_modello,
        })
        .finally(() => {
          this.new_fix_text = null;
          this.dialog_new_text = false;
        });
    },
    delete_text(id) {
      this.$store.dispatch("elimina_testo_broadcast", id);
    },
    cliente(iva) {
      return this.clienti.find((cliente) => cliente.iva == iva);
    },
    isValidItalianPhoneNumber(phoneNumber) {
      // Rimuove eventuali spazi, trattini o parentesi
      if (typeof phoneNumber !== 'string') {
        return false;
      }
      const cleaned = phoneNumber.replace(/[\s\-()]/g, '');
    
      // Espressione regolare per numeri di telefono italiani
      const regex = /^(?:(?:\+|00)39)?(?:3[1-6][0-9]{8}|0[1-9][0-9]{1,9})$/;
    
      return regex.test(cleaned);
    },
  },
};
